import React from "react";
import { CurrencyValue } from "interfaces/data";
import { formatNumberToString } from "helpers/formatNumber";

export function CurrencyValueCell(arg: any) {
  const { quantity, currency } = arg.value as CurrencyValue;
  return <>{`${formatNumberToString(quantity)} ${currency}`}</>;
}
